import { apiClient } from '@/libs/http-client';

// override instance default 'api base url' with 'middleware base url'
const prefixUrl = import.meta.env.VITE_MIDDLEWARE_BASE_URL;

export const calibrate = async (imageString: string) => {
  return apiClient()
    .post('Calibrate', {
      prefixUrl,
      json: { imageString },
    })
    .json();
};
